class Wishlist {
	constructor() {
		this.buildWishlistButton();
		this.buildWishlistPage();
	}

	buildWishlistButton() {
		this.wishlistContainer = document.querySelector(".wishlist-container");
		if (!this.wishlistContainer) {
			return;
		}


		gsap.to(this.wishlistContainer , {
			opacity: 1,
			duration: 0.3,
			pointerEvents: "initial",
			scrollTrigger: {
				trigger: ".banner",
				start: 'center top',
				end: "+=300",
				scrub: 1,
			}
		});

		const open = document.querySelector(".toggle-wishlist");
		open.addEventListener("click", () => {
			this.wishlistContainer.classList.add("open");
		});

		const close = document.querySelector(".close-wishlist");
		close.addEventListener("click", () => {
			this.wishlistContainer.classList.remove("open");
		});

		this.openWishlist = document.querySelectorAll(".open-wishlist");
		this.counter = this.wishlistContainer.querySelector(".counter");

		this.updateOpenWishlistButton();

		this.flyingHeart = document.querySelector(".flying-heart");
		this.addToWishlist = document.querySelector(".add-to-wishlist");
		this.addToWishlist.addEventListener("click", () => {
			this.addProduct(this.addToWishlist.dataset.productRef);
		});
	}

	getWishlist() {
		let items = [];
		let wishlist = localStorage.getItem("jlfpro.wishlist");
		if (wishlist) {
			items = wishlist.split(";");
		}
		return items;
	}

	setWishlist(items) {
		localStorage.setItem("jlfpro.wishlist", items.join(";"));
	}

	updateOpenWishlistButton() {
		const wishlist = this.getWishlist();
		this.openWishlist.forEach(button => {
			let url = button.getAttribute("href") + "?wishlist=";
			url = url + wishlist.join(";");
			button.setAttribute("href", url);
		});
		this.counter.innerHTML = wishlist.length;
	}

	addProduct(ref) {
		const items = this.getWishlist();
		if (!items.includes(ref)) {
			items.push(ref);
		}
		this.setWishlist(items);
		this.updateOpenWishlistButton();
		this.flyMyLittleHeart();
	}

	flyMyLittleHeart() {
		const clone = this.flyingHeart.cloneNode();
		this.addToWishlist.appendChild(clone);
		gsap.set(clone, {willChange: "opacity, transform"});
		gsap.to(clone, {
			y: "-100px",
			opacity: 0,
			scale: 2,
			duration: 2,
			onComplete: () => {
				clone.remove();
			}
		});
		const tl = gsap.timeline();
		tl.to(clone, {x: "10px", duration: 0.5, ease: "power2.out"})
			.to(clone, {x: "0px", duration: 0.5, ease: "power2.in"})
			.to(clone, {x: "-15px", duration: 0.5, ease: "power2.out"})
			.to(clone, {x: "0px", duration: 0.5, ease: "power2.in"})
			.to(clone, {x: "15px", duration: 0.5, ease: "power2.out"})
			.to(clone, {x: "0px", duration: 0.5, ease: "power2.in"})
			.to(clone, {x: "-20px", duration: 0.5, ease: "power2.out"})
			.to(clone, {x: "0px", duration: 0.5, ease: "power2.in"});
	}

	buildWishlistPage() {
		if (!document.body.classList.contains("page-template-template-wishlist")) {
			return;
		}

		this.hiddenInput = document.querySelector("#wishlistContent");
		this.updateHiddenInput();

		const storedWishlist = this.getWishlist();
		const onpageWishlist = document.querySelectorAll(".wishlist-item");
		if (storedWishlist.length !== onpageWishlist.length) {
			var searchParams = new URLSearchParams(window.location.search);
			searchParams.set("wishlist", storedWishlist.join(";"));
			window.location.href = window.location.pathname + '?' + searchParams.toString();
		}

		document.querySelectorAll(".wishlist-item .remove").forEach(remove => {
			remove.addEventListener("click", () => {
				const item = remove.closest(".wishlist-item");
				const ref = item.dataset.ref;
				const current = this.getWishlist();
				const index = current.indexOf(ref);
				if (index > -1) {
					current.splice(index, 1); // 2nd parameter means remove one item only
				}
				this.setWishlist(current);
				var searchParams = new URLSearchParams(window.location.search);
				searchParams.set("wishlist", current.join(";"));
				const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
				history.pushState(null, '', newRelativePathQuery);
				item.remove();
				if (current.length === 0) {
					document.querySelector(".empty-wishlist").classList.remove("d-none");
				}
				this.updateHiddenInput();
			});
		});

		document.querySelectorAll(".wishlist-item .quantity").forEach(quantityInput => {
			quantityInput.addEventListener("change", () => {
				this.updateHiddenInput();
			});
		});
	}

	updateHiddenInput() {
		this.hiddenInput.value = "";
		document.querySelectorAll(".wishlist-items .wishlist-item").forEach(item => {
			const ref = item.dataset.ref;
			const quantity = item.querySelector(".quantity").value;
			this.hiddenInput.value = this.hiddenInput.value + "Référence : " + ref + ", quantité : " + quantity + " - \r\n";
		});
	}
}
